import { PartImageItem, PartImageItemBox, PartImageItemRegion } from '@/api/generatedApi';
import { snapBoxToSegments } from '@physna/core/domain/part-image-identification/part-image-segments';
import { PartImageSegmentsByPhoto } from '@/hooks/api/part-finder-image-search/usePartImageSegments';

const snapRegion = (region: PartImageItemRegion, segments: PartImageSegmentsByPhoto): PartImageItemRegion => {
  const photoSegments = segments.get(region.photoNumber);
  if (!photoSegments || region.fitted) return region;
  const { left, top, width, height } = region;
  return { photoNumber: region.photoNumber, ...snapBoxToSegments({ left, top, width, height }, photoSegments) };
};

export const snapPartImageItems = (items: PartImageItem[], segments?: PartImageSegmentsByPhoto): PartImageItem[] =>
  segments
    ? items.map(item => ({ ...item, regions: item.regions.map(region => snapRegion(region, segments)) }))
    : items;

const inPhoto = (value: number): number => Math.min(Math.max(value, 0), 1);

export const clampToPhoto = (region: PartImageItemRegion): PartImageItemBox => {
  const left = inPhoto(region.left);
  const top = inPhoto(region.top);
  return {
    left,
    top,
    width: inPhoto(region.left + region.width) - left,
    height: inPhoto(region.top + region.height) - top,
  };
};

const hasArea = (box: PartImageItemBox): boolean => box.width > 0 && box.height > 0;

export const firstRegionBox = (item: PartImageItem): PartImageItemBox | undefined =>
  item.regions
    .slice(0, 1)
    .map(region => clampToPhoto(region))
    .find(box => hasArea(box));
